import { render } from "./sop.vue?vue&type=template&id=faed933e"
import script from "./sop.vue?vue&type=script&lang=js"
export * from "./sop.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__